var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 18 9" }, props),
    React.createElement("path", { d: "M15.4 2.6C13.6.9 11.3 0 9 0c-.7 0-1.4.1-2 .2-.2 0-.3.3-.1.4L9.6 3s.1 0 .1.1c1.3.2 2.5.8 3.5 1.7 1.1 1.1 1.7 2.6 1.8 4 0 .1.1.2.2.2h2.5c.2 0 .3-.1.3-.3-.1-2.2-1-4.4-2.6-6.1zM8.9 5L3.7.6C3.5.5 3.4.4 3.2.4s-.4.1-.6.2c-.3.3-.3.7-.1 1L7 6.9c0 .5.2 1.1.6 1.5.8.8 2.1.8 2.8 0 .8-.8.8-2.1 0-2.8-.4-.4-.9-.6-1.5-.6zm-7-1c-.1-.1-.3-.1-.4 0C.6 5.4.1 7.1 0 8.7c0 .2.1.3.3.3h2.5c.1 0 .2-.1.2-.2 0-.9.2-1.7.7-2.5V6L1.9 4z" })
  );
});